/*
 * Copyright (c) Outright Mental. (https://outrightmental.com) All Rights Reserved.
 */

export const
  MILLIS_PER_SECOND = 1000,
  TICKS_PER_SECOND = 4,
  GAME_DAYS_PER_SECOND = 1,
  GAME_CYCLE_PAYROLL_DAYS = 14,
  GAME_CYCLE_EXPENSE_DAYS = 30,
  GAME_CYCLE_MARKET_DAYS = 91.25;

export const MONEY = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  roundingType: 'compactRounding',
  notation: 'compact',
  compactDisplay: 'short',
});

export const
  DEPARTMENT_TYPE_OPS = "ops",
  DEPARTMENT_TYPE_HR = "hr",
  DEPARTMENT_TYPE_LEGAL = "legal",
  DEPARTMENT_TYPE_IT = "it",
  DEPARTMENT_TYPE_MARKETING = "marketing";

export const
  PLAYER_MESSAGE_TYPE_PAYROLL = "payroll",
  PLAYER_MESSAGE_TYPE_EXPENSE = "expense",
  PLAYER_MESSAGE_TYPE_MARKET = "market",
  PLAYER_MESSAGE_TYPE_INFO = "info";

export const
  DEPARTMENT_TYPES = [
    DEPARTMENT_TYPE_OPS,
    DEPARTMENT_TYPE_HR,
    DEPARTMENT_TYPE_LEGAL,
    DEPARTMENT_TYPE_IT,
    DEPARTMENT_TYPE_MARKETING,
  ],
  DEPARTMENTS = {
    [DEPARTMENT_TYPE_OPS]: {
      name: "Operations Management",
      requires: [],
      openingCost: -1,
      expenseCost: 1000,
      daysToOpen: -1,
    },
    [DEPARTMENT_TYPE_HR]: {
      name: "HR dept.",
      requires: ["ops"],
      openingCost: 50000,
      expenseCost: 5000,
      daysToOpen: 7,
    },
    [DEPARTMENT_TYPE_LEGAL]: {
      name: "Legal dept.",
      requires: ["hr"],
      openingCost: 100000,
      expenseCost: 10000,
      daysToOpen: 14,
    },
    [DEPARTMENT_TYPE_IT]: {
      name: "IT dept.",
      requires: ["legal"],
      openingCost: 150000,
      expenseCost: 15000,
      daysToOpen: 26,
    },
    [DEPARTMENT_TYPE_MARKETING]: {
      name: "Marketing dept.",
      requires: ["legal", "it"],
      openingCost: 250000,
      expenseCost: 25000,
      daysToOpen: 39,
    },
  };


// Constants to identify requests handled by the api ORM Reducer
export const
  DEPARTMENT_CLOSE = 'DEPARTMENT_CLOSE',
  DEPARTMENT_CLOSING_DONE = 'DEPARTMENT_CLOSING_DONE',
  DEPARTMENT_OPEN = 'DEPARTMENT_OPEN',
  DEPARTMENT_OPENING_DONE = 'DEPARTMENT_OPENING_DONE',
  PERSON_HIRE = 'PERSON_HIRE',
  PERSON_HIRING_DONE = 'PERSON_HIRING_DONE',
  PERSON_TERMINATE = 'PERSON_TERMINATE',
  PERSON_TERMINATION_DONE = 'PERSON_TERMINATION_DONE';

// Potential states of a Department
export const
  DEPARTMENT_STATE_OPENED = 'DEPARTMENT_STATE_OPENED',
  DEPARTMENT_STATE_OPENING = 'DEPARTMENT_STATE_OPENING',
  DEPARTMENT_STATE_CLOSED = 'DEPARTMENT_STATE_CLOSED',
  DEPARTMENT_STATE_CLOSING = 'DEPARTMENT_STATE_CLOSING';
